import t from 'tcomb-form';
import {ValidationError} from 'validators';


export default t.subtype(t.Str, (n) => {
    try {
        const re = /^([01]\d|2[0-3]):?([0-5]\d)$/;
        if (n.match(re)) {
            return true;
        } else {
            throw ValidationError;
        }
    }

    catch(e) {
        if (e instanceof ValidationError) {
            return false;
        }

        throw e;
    }
});



/** WEBPACK FOOTER **
 ** ./app/src/forms/validators/time.js
 **/